import { axiosSEC } from "../http-common";
import { IAvulso, ICobranca } from "../types/TicketInterface";

const valorVazio = 0; // Constante usada para passar um valor vazio no id da forma de pagamento, obrigando a rota a pesquisar pela bandeira de pagamento ao invés do id

const getAvulso = async (idEstacionamento: string, codigoTicket: string, idToken: string) => {
  let response = await axiosSEC.get<IAvulso>("Avulso/" + idEstacionamento + '/' + codigoTicket + '/' + idToken);
  return response;
};

const postCalculaCobranca = async (idToken: string, strCodigo: string) => {
  var requestObject = {
    "idtoken": idToken,
    "strcodigo": strCodigo
  }

  let response = await axiosSEC.post<ICobranca>("CalculaCobrancaOnline", requestObject);
  return response;
}

const postConfirmaPagamento = async () => {
  var ticket = JSON.parse(localStorage.getItem('ticket')!) as IAvulso;
  var cobranca = JSON.parse(localStorage.getItem('cobranca')!) as ICobranca;

  var requestObject = {
    "strCodigo": ticket.strcodigo,
    "idtoken": localStorage.getItem('idToken')!.toString(),
    "lstPagamentos": [
      {
        "douvalor": cobranca.douValorCobrado,
        "idtblformapagamento": valorVazio,
        "stridentificacaobandeira": localStorage.getItem('bandeira')!.toString()
      }
    ],
    "strDocumento": localStorage.getItem('CPF/CNPJ')
  };
  let response = await axiosSEC.post("ConfirmaPagamentoOnline", requestObject);
  return response;
}

const TicketService = {
  getAvulso, postCalculaCobranca, postConfirmaPagamento
};

export default TicketService;